import Config from "../config.js";
import { createRequestOptions } from "./utils";
import { get } from "lodash";

export default () => {
  return Object.freeze({
    submitCSATResponse: async (
      appId,
      userId,
      isAnon,
      wasDeclined,
      providerUserId,
      clinicRating,
      clinicComment,
      providerRating,
      providerComment
    ) => {
      const options = createRequestOptions({
        appId,
        userId,
        isAnon,
        wasDeclined,
        providerUserId,
        clinicRating,
        clinicComment,
        providerRating,
        providerComment,
      });
      const result = await fetch(
        Config.serverUrl + "/SubmitCSATResponse",
        options
      );
      const response = await result.json();

      return get(response, "response");
    },
    getCSATScoreForApp: async (appId) => {
      const options = createRequestOptions({
        appId,
      });
      const result = await fetch(
        Config.serverUrl + "/GetCSATScoreAndResponses",
        options
      );
      const response = await result.json();

      return get(response, "response");
    },
  });
};



// WEBPACK FOOTER //
// ./src/services/csat.js